import { AccordeonComponent } from './accordeon'
import { BaseComponent } from '../base-component'
import { isEnterKey } from '../../utils/key'
import { $elParent } from 'src/scripts/utils/utils'

const ACCORDEON_SELECTOR = 'accordeon-component'

export class AccordeonButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleButtonClick)
    this.addListener(this, 'keydown', this.handleKeyDown)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.toggle()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.toggle()
    }
  }

  toggle(): void {
    const accordeon: AccordeonComponent = $elParent(ACCORDEON_SELECTOR, this)
    accordeon?.toggle()
  }
}
